import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RunListComponent } from './run-list/run-list.component';
import { RunDetailComponent } from './run-detail/run-detail.component';
import { SampleListComponent } from './sample-list/sample-list.component';
import { SampleDetailComponent } from './sample-detail/sample-detail.component';
import { AuthGuard } from '@auth0/auth0-angular';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { BioseqAdminGuard } from './guards/bioseq-admin.guard';
import { RetestListComponent } from './retest-list/retest-list.component';

const routes: Routes = [

  { path: 'sample-list', component: SampleListComponent, canActivate: [AuthGuard, BioseqAdminGuard]  },
  { path: 'sample-detail', component: SampleDetailComponent, canActivate: [AuthGuard, BioseqAdminGuard]  },
  { path: 'retest-list', component: RetestListComponent, canActivate: [AuthGuard, BioseqAdminGuard]  },
  { path: 'run-list', component: RunListComponent, canActivate: [AuthGuard, BioseqAdminGuard]  },
  { path: 'run-detail', component: RunDetailComponent, canActivate: [AuthGuard, BioseqAdminGuard]  },
  { path: 'unauthorized', component: UnauthorizedComponent, canActivate: [AuthGuard] },
  { path: '', redirectTo: 'run-list', pathMatch: 'full' },
  { path: '**', redirectTo: 'run-list' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
